<main id="content" tabindex="-1" class="m-0">
    <div id="homepage-top" class="col col-md-12 col-lg-8 col-xl-9 py-0 px-0">
        <app-recommender></app-recommender>
    </div>
    <div id="home-page-tab-controls" class="d-block d-lg-none">
        <ul class="nav nav-tabs" role="tablist">
            <li class="nav-item w-50" role="presentation" (click)="activeNav=1">
                <button [ngClass]="{'active':activeNav==1}" class="nav-link fw-bold w-100" id="profile-tab" data-bs-toggle="tab" data-bs-target="#announcement-pane" type="button" role="tab" aria-controls="announcement-pane" aria-selected="false">Announcements</button>
            </li>
            <li class="nav-item w-50" role="presentation" (click)="activeNav=2">
                <button [ngClass]="{'active':activeNav==2}" class="nav-link fw-bold w-100" id="contact-tab" data-bs-toggle="tab" data-bs-target="#events-pane" type="button" role="tab" aria-controls="events-pane" aria-selected="false">Dates and Events</button>
            </li>
        </ul>
    </div>
    <div [ngClass]="{'tab-content': isMobile(), 'border-start' : isMobile(), 'border-end': isMobile()}" class="m-0 p-0 row" style="height:100%;">
        <div class="" [ngClass]="{'tab-pane':isMobile(),'show':isMobile(),'fade':isMobile(),'active':activeNav==1,'col-lg-8 col-xl-9': !isMobile()}" id="announcement-pane" role="tabpanel">
            <app-timeline></app-timeline>
        </div>
        <div class="" [ngClass]="{'bg-white': isMobile(),'tab-pane':isMobile(),'fade':isMobile(),'show':isMobile(),'col-lg-4 col-xl-3': !isMobile(),'active':activeNav==2}" id="events-pane" role="tabpanel">
            <app-calendar [ngClass]="{'isMobile': isMobile(), 'isDesktop': !isMobile() }" style="top:-{{calendarOffset}}px"></app-calendar>
        </div>
    </div>
</main>
